import React, { useState } from "react";
import ActionButton from "controls/global/action-button";
import SendMessageDocumentDialog from "./SendMessageDocumentDialog";
import { v4 as uuidv4 } from "uuid";
import SendMessageIcon from "theme/icons/SendMessageIcon";
import { gaps } from "theme/defaultStyle";

type SendMessageDocumentProps = {
  disabled: boolean;
  productIndex: number;
  parentIntegrationKey ?: string;
  performSearchDocument?: () => Promise<void>;
};

export const SendMessageDocument: React.FC<SendMessageDocumentProps> = ({ disabled = false, productIndex ,parentIntegrationKey, performSearchDocument }) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [keys, setKeys] = useState<string>("");
  
  return (
    <div>
      <ActionButton
        disabled={disabled}
        onClick={() => {
          setKeys(uuidv4());
          setIsDialogOpen(true);
        }}
        variant="outlined"
        color="secondary"
        startIcon={<SendMessageIcon />}
        sx={{ gap: gaps.zero }}
      >
        Send Message/Documents
      </ActionButton>

      <SendMessageDocumentDialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        key={keys}
        notDisabled={true}
        productIndex={productIndex}
        parentIntegrationKey={parentIntegrationKey}
        performSearchDocument={performSearchDocument}
      />
    </div>
  );
};
